<template>
    <div class="card">
        <div class="card-title"><label  v-if="!!title" >{{title}}</label></div>
        <div class="card-body">
            <input type="file" name="files" class="file-input"  @change="setFile($event.target.files)" multiple/>
            <div class="file-list alert alert-info mt-2" v-if="!!files.length">
                <h5>Archivos seleccionados</h5>
                <div class="file-item" v-for="(file, index) in files">
                    {{ index + 1 }} - {{ file.name }}
                </div>
            </div>
            <div v-if="files.length" class="buttons text-right" slot="buttons">
                <button class="btn btn-danger" @click.prevent="clearFiles">Cancelar selección de archivos</button> 
            </div>
        </div>       
    </div>
</template>
<script>
export default {
   
   props: {
       id: {
            type: String,
            default: () => {
                return `uploadfile-${parseInt(Math.random()*100)}`;
            }
        },
        title: {
            type: String,
            default: ''
        }
   },
   
   data(){
        return{
            files: [],
        }
    },

    methods:{
        setFile(files){
                if(Object.keys(files).length > 0){
                    Object.keys(files).map(key => this.files.push(files[key]));
                    this.$emit('input', {
                        files: this.files
                    });
                    $(`.file-input`).val('');
                }
            },
            clearFiles(){
                this.files = [];
                $(`.file-input`).val('');
                this.$emit('input', {
                    files: this.files
                });
            }
    },

    created(){
            this.$bus.$on(`${this.id}.clean`, this.clearFiles);
        }
}
</script>
